export class LatLngStatic {
    constructor(lat: number, lng: number) {
        this.lat = lat;
        this.lng = lng;
    }

    lat: number;
    lng: number;
}
